var AddressBillingFormView = (function (_baseView, _fieldView, _getPageTemplate, _globalSettings) {

    var prePaymentRout = 'checkout.address.giftbilling.billing.form';
    var switchRout = 'checkout.address.switch.billing.form';

    var _progressClassName = 'processing-animation';

    return _baseView.extend({
        el: '@newBillingAddress',

        displayRoutes: ['checkout.address.billing.form', prePaymentRout],

        events: {
            'click @btnAddAddress': 'addAddress'
        },

        initialize: function () {
            _.bindAll(this, '_toggleDeliveryType', 'render');

            this.$fields = this.$('@fields');

            this.collection.ready(this.render);
            //this.listenTo(this.collection, 'add', _.bind(this._renderField, this));
            this.listenTo(this.collection, 'deliveryTypeChange', this._toggleDeliveryType);

        },

        render: function () {
            this.collection.each(_.bind(this._renderField, this));
        },

        addAddress: function (e) {
            e.preventDefault();
            //window.app && app.event && app.event.useThisAddress();

            this.$('@btnAddAddress').addClass(_progressClassName);

            this.collection.save()
                .done(_.bind(this._saved, this))
                .fail(_.bind(this._failed, this))
                .always(_.bind(function () {
                    this.$('@btnAddAddress').removeClass(_progressClassName);
                }, this));
        },

        beforeShow: function (data) {
            this._backTo = data ? data.backTo : null;
            this._onSavedCallback = data ? data.callback : null;
            //data && this.collection.setDeliveryType(data.deliveryType);
        },

        _renderField: function (model) {
            var field = new _fieldView({ model: model });
            this.$fields.append(field.$el);
        },

        _saved: function () {
            if (this._onSavedCallback) {
                this._onSavedCallback();
            } else {
                this.display(this._backTo || 'checkout');
            }
        },

        _failed: function () {
            alert(_getPageTemplate('_FillAllFields'));
        },

        _toggleDeliveryType: function (type) {
            //this.type = type;
            this.$('@signature').toggleClass('hidden-block', type !== CheckoutSettings.addressDeliveryTypes.signature);
            this.$('@pickup').toggleClass('hidden-block', type !== CheckoutSettings.addressDeliveryTypes.pickup);
            this.collection.each(function (model) {
                var name = model.get('Name') || '';
                var isHidden = !(type !== CheckoutSettings.addressDeliveryTypes.pickup || name.match(/^(Name|Phone)$/i));
                model.setHidden(isHidden);
            });
        }
    });
})(BaseView, FieldView, kos.getPageTemplate, GlobalSettings);